class CookieEventService {
    constructor() {
        window.addEventListener('click', this.handleClick);
        this.handleLoad();
    }

    private handleLoad() {
        if (document.readyState !== 'loading') {
            this.handleParams();
        } else {
            document.addEventListener('DOMContentLoaded', this.handleParams);
        }
    }

    private handleParams = () => {
        const params = new URLSearchParams(window.location.search);
        const hasCookieSettings = params.has('cookie-settings') || params.has('cookie-instellingen');
        if (hasCookieSettings) {
            setTimeout(() => {
                const overlay = document.querySelector('web-overlay');
                if (!overlay.getAttribute('overlay-visible') || overlay.getAttribute('overlay-visible') === 'false') {
                    this.openCookieWall();
                }
            }, 500);
        }
    };

    private handleClick = (event: Event) => {
        const link = (event.target as Element).closest('a');
        if (!link) {
            return;
        }

        switch (link.getAttribute('data-event')) {
            case 'cookie-dialog':
                event.stopPropagation();
                event.preventDefault();

                this.openCookieWall();
                break;

            default:
        }
    };

    private openCookieWall = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        document.querySelector<any>('web-overlay:has(web-cookie-consent)')?.open({ modal: false });
    };
}

const instance = new CookieEventService();

export const getInstance = () => instance;
